import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class FacilityTypeService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<FacilityType[]> => {
    return this.apiHttp.get<FacilityType[]>("facilitytypes");
  };

  public get = (id: number): Observable<FacilityType> => {
    return this.apiHttp.get<FacilityType>(`facilitytypes/${id}`);
  }
}

export interface FacilityType {
  id: number;
  name: string;
  isActive: boolean;
  order: number;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/facility-type.service.ts